import { Outlet } from 'react-router-dom';

// ==============================|| MINIMAL LAYOUT ||============================== //

const AuthLayout = () => (
    <>
        <Outlet />
    </>
);

export default AuthLayout;
